export const ACTOR_TYPES = [
  "character",
  "npc",
  "vehicle"
];

/* -------------------------------------------- */

export const PROPERTIES = [
  "activeEffect.deleted",
  "activeEffect.disabled",
  "actor.hasArcaneBackground",
  "actor.inCombat",
  "actor.isEncumbered",
  "actor.itemCreated",
  "actor.itemDeleted",
  "actor.name",
  "actor.system.advances.mode",
  "actor.system.advances.rank",
  "actor.system.advances.value",
  "actor.system.attributes.agility.die.sides",
  "actor.system.attributes.agility.die.modifier",
  "actor.system.attributes.agility.wild-die.sides",
  "actor.system.attributes.smarts.animal",
  "actor.system.attributes.smarts.die.sides",
  "actor.system.attributes.smarts.die.modifier",
  "actor.system.attributes.smarts.wild-die.sides",
  "actor.system.attributes.spirit.die.sides",
  "actor.system.attributes.spirit.die.modifier",
  "actor.system.attributes.spirit.unShakeBonus",
  "actor.system.attributes.spirit.wild-die.sides",
  "actor.system.attributes.strength.die.sides",
  "actor.system.attributes.strength.die.modifier",
  "actor.system.attributes.strength.encumbranceSteps",
  "actor.system.attributes.strength.wild-die.sides",
  "actor.system.attributes.vigor.bleedOut.modifier",
  "actor.system.attributes.vigor.bleedOut.ignoreWounds",
  "actor.system.attributes.vigor.die.sides",
  "actor.system.attributes.vigor.die.modifier",
  "actor.system.attributes.vigor.soakBonus",
  "actor.system.attributes.vigor.unStunBonus",
  "actor.system.attributes.vigor.wild-die.sides",
  "actor.system.bennies.value",
  "actor.system.bennies.max",
  "actor.system.details.autoCalcParry",
  "actor.system.details.autoCalcToughness",
  "actor.system.details.conviction.value",
  "actor.system.details.conviction.active",
  "actor.system.details.currency",
  "actor.system.details.encumbrance.value",
  "actor.system.details.encumbrance.max",
  "actor.system.details.species.name",
  "actor.system.details.wealth.die",
  "actor.system.details.wealth.modifier",
  "actor.system.details.wealth.wild-die",
  "actor.system.fatigue.value",
  "actor.system.fatigue.min",
  "actor.system.fatigue.max",
  "actor.system.fatigue.ignored",
  "actor.system.initiative.hasHesitant",
  "actor.system.initiative.hasImpLevelHeaded",
  "actor.system.initiative.hasLevelHeaded",
  "actor.system.initiative.hasQuick",
  "actor.system.powerPoints.general.value",
  "actor.system.powerPoints.general.max",
  "actor.system.stats.parry.value",
  "actor.system.stats.parry.modifier",
  "actor.system.stats.scale",
  "actor.system.stats.size",
  "actor.system.stats.speed.runningDie",
  "actor.system.stats.speed.runningMod",
  "actor.system.stats.speed.value",
  "actor.system.stats.speed.adjusted",
  "actor.system.stats.toughness.value",
  "actor.system.stats.toughness.armor",
  "actor.system.stats.toughness.modifier",
  "actor.system.status.isBound",
  "actor.system.status.isDistracted",
  "actor.system.status.isEntangled",
  "actor.system.status.isIncapacitated",
  "actor.system.status.isShaken",
  "actor.system.status.isStunned",
  "actor.system.status.isVulnerable",
  "actor.system.wildcard",
  "actor.system.wounds.value",
  "actor.system.wounds.min",
  "actor.system.wounds.max",
  "actor.system.wounds.ignored",
  "actor.system.woundsOrFatigue.ignored",
  "item.name",
  "item.system.equipped",
  "item.system.quantity",
  "item.system.weight",
  "token.disposition",
  "token.elevation",
  "token.name",
  "token.rotation",
  "token.sight.angle",
  "token.sight.attenuation",
  "token.sight.brightness",
  "token.sight.color",
  "token.sight.contrast",
  "token.sight.enabled",
  "token.sight.range",
  "token.sight.saturation",
  "token.sight.visionMode"
];

/* -------------------------------------------- */

export const DERIVED_PROPERTIES = [
  "actor.hasArcaneBackground",
  "actor.isEncumbered"
];
